// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__KKcTz","logo":"Header_logo__mnrgw","title":"Header_title__g29kX"};